export default __webpack_public_path__ + "static/media/Texans.08085b8e.png";